import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { SortingOptions } from "@/sorting/SortingOptions";
import { AttendanceFilterOptionValue, FilterKey } from "@studyportals/search-filters";
import { SeoHeadingHandler } from "../../SeoHeadingHandler";

export class AreaAttendanceOnline extends SeoHeadingHandler {
	
	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankSortingSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const deliveryMethodSelected = await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const deliveryMethod = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const areaSelected = await this.singleSelectionFor(FilterKey.AREA, filterSelectionState);
		const countrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const selectedTypeCount = this.selectionTypeCount(filterSelectionState);

		return metaRankSortingSelected
			&& (deliveryMethodSelected
				&& deliveryMethod === AttendanceFilterOptionValue.ONLINE
				&& areaSelected
				&& (selectedTypeCount === 2 || (selectedTypeCount === 3 && countrySelected)));
	}

	protected selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);

		const seoInfo = `Best Online Universities in ${area} | Studyportals University Meta Ranking`;

		return Promise.resolve(seoInfo);
	}
}
